<ng-container *ngIf="linkData">
	<a
		[href]="linkData.url | copoSafeUrl"
		target="_blank"
		[type]="linkData.type"
		[title]="linkData.titleTranslation || 'sb.Download' | translate">
		<mat-icon [svgIcon]="linkData.icon" class="copo-datacenter-grid-icon-16"></mat-icon>
	</a>
</ng-container>
